import React from 'react';

interface RemarksCellProps {
  comments: string;
}

export function RemarksCell({ comments }: RemarksCellProps) {
  const [isExpanded, setIsExpanded] = React.useState(false);
  // Tracks whether the paragraph is actually overflowing its clamped height.
  // Used to avoid rendering the toggle button for short text that fits within
  // the clamp limit.
  const [isClamped, setIsClamped] = React.useState(false);
  const textRef = React.useRef<HTMLParagraphElement>(null);

  // Measure overflow after every render where the clamp class is active.
  // useLayoutEffect ensures the DOM has been updated before we read dimensions,
  // preventing a flash of the button appearing then disappearing.
  React.useLayoutEffect(() => {
    const el = textRef.current;
    if (el && !isExpanded) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, [comments, isExpanded]);

  return (
    <div>
      <p ref={textRef} className={isExpanded ? undefined : 'line-clamp-3'}>
        {comments}
      </p>
      {isClamped && (
        <button
          type="button"
          onClick={() => setIsExpanded((prev) => !prev)}
          className="text-primary-600 mt-0.5 text-xs font-medium hover:underline"
        >
          {isExpanded ? 'Show less' : 'Show more'}
        </button>
      )}
    </div>
  );
}
